import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    title: "Most API",
    logo: {
      src: {
        light: "/logo-light.svg",
        dark: "/logo-dark.svg",
      },
      alt: "Most API",
      width: "130px",
      // Point logo directly at /introduction so clicking it is a
      // single SPA navigation rather than `/` → redirect → mount
      // Introduction on top of the already-mounted Introduction,
      // which was producing a visible duplicated-page bug.
      href: "/introduction",
    },
    showPoweredBy: false,
  },
  metadata: {
    title: "Most API — Documentation",
    description: "Domain registration API across multiple registrars",
    favicon: "/favicon.svg",
  },
  theme: {
    customCss: `
      :root { --sidecar-grid-cols: 1fr 1fr !important; }
      .code-block { max-height: 500px !important; }
    `,
  },
  navigation: [
    {
      type: "category",
      label: "Introduction",
      icon: "sparkles",
      items: ["/introduction", "/registrar-peculiarities", "/domain-migration"],
    },
    {
      type: "link",
      label: "API Reference",
      to: "/api",
      icon: "book-open",
    },
    {
      type: "category",
      label: "Webhooks",
      icon: "webhook",
      link: "/webhooks",
      items: [
        "/webhooks",
        { type: "section", label: "Event families" },
        "/webhooks/account",
        "/webhooks/operations",
      ],
    },
    {
      type: "category",
      label: "Tools",
      icon: "wrench",
      items: ["/tools"],
    },
    {
      type: "category",
      label: "BrandShield",
      icon: "shield-check",
      items: ["/brandshield", "/brandshield-api"],
    },
  ],
  // No client-side redirects. `/` is handled server-side by the 301
  // redirect in serve.json → /introduction; the logo link goes
  // straight to /introduction so SPA navigation never hits `/` and
  // can't trigger a self-redirect during hydration.
  apis: [
    {
      type: "file",
      input: "./apis/openapi.json",
      path: "/api",
      options: {
        examplesLanguage: "shell",
        showInfoPage: false,
      },
    },
  ],
  // Full-text search across every MDX page and every OpenAPI operation.
  // Pagefind is a static, client-side index — no external service, no
  // auth, zero runtime cost. Hotkey ⌘K / Ctrl+K opens the search modal.
  search: {
    type: "pagefind",
    maxSubResults: 3,
  },
};

export default config;
